exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".qrContainer-258751c4{margin-top:20px}.qrCode-e5d98e6a{padding:5px;margin:15px 0px;border:1px solid #E0E0E0;border-radius:4px;width:80px;height:80px;box-sizing:content-box}.qrCode-e5d98e6a.centered-49db022e{display:flex;justify-content:center;width:200px;height:200px;margin:15px auto}.secondaryDownload-77f42bea{color:#616161 !important;width:80px !important;padding-left:0 !important;padding-right:0 !important;text-align:right !important}\n", ""]);

// Exports
exports.locals = {
	"qrContainer": "qrContainer-258751c4",
	"qrCode": "qrCode-e5d98e6a",
	"centered": "centered-49db022e",
	"secondaryDownload": "secondaryDownload-77f42bea"
};